import { createFileRoute } from '@tanstack/react-router';
import { auditLogRouteOptions } from '../-workspaceRouteOptions';

export const Route = createFileRoute('/_authed/$orgSlug/audit-log')({
  ...auditLogRouteOptions,
});
